module.exports = {"data":{"site":{"siteMetadata":{"title":"Sunny Crest","description":"A site dedicated to the restoration of Sunny Crest"}}},"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/index.json
// module id = 371
// module chunks = 142629428675168